<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-3">

          </div>
          <div class="row" v-if="camp.id">
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                      <i class="fas fa-bullhorn fa-2x"></i> 
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>نام کمپین</span>
                    <h1 classfa-truck-moving="font-bold main-card__data">
                      {{ camp && camp.title ? camp.title : '' }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                    <i class="fas fa-wallet fa-2x"></i>          
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>مبلعغ مشارکت در کمپین</span>
                    <h2 class="font-bold main-card__data">
                      {{ camp && camp.amount_payable ? camp.amount_payable : '' }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                    <i class="fas fa-users fa-2x"></i>           
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>تعداد مشارکت</span>
                    <h1 class="font-bold main-card__data">
                   {{ camp && camp.participation_count ? camp.participation_count : '' }} نفر
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="widget home style1">
                <div class="row">
                  <div class="col-4">
                    <div class="main-card__icon-container">
                      <i class="fas fa-calendar-alt fa-2x"></i>    
                    </div>
                  </div>
                  <div class="col-8 text-right">
                    <span>تاریخ اتمام</span>
                    <h1 class="font-bold main-card__data">
                    {{ camp && camp.expire_at ? $getJalaliDateTime(camp.expire_at) : '' }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
            <bita-grid ref="grid" :columns="gridColumns" 
            :read-data="readData"
            :hasRow="false"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
           />
        </div>
      </bita-ibox>
    </div>

  </div>
</template>
<script>


export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "کمپین ها", link: "/campaigns" },
        { title: "لیست مشارکت", link: "/campaigns/participation",active: true,},
      ],
      isLoadingGrid: false,
      pageSize:0,
      currentPage:0,
      total:{},
      camp:{}

    };
  },
  computed: {

    gridColumns() {
      return [
        { title: "#", template: this.$getTemplate, width: "10px" },
        { field: "driver.full_name", title: "نام و نام خانوادگی", width: "60px",footerTemplate: () => `  مشارکت در کمپین : ${this.total ?? 0} نفر`},
        { field:"driver.national_code",title: "کد ملی", width: "40px" },
        { field:"driver.phone",title: "شماره تماس", width: "40px" },

        {
          field: "updated_at",
          title: "تاریخ",
          template: (e) =>
            e.updated_at ? this.$getJalaliDateTime(e.updated_at) : "",
          width: "60px",
        },

      ];
    },
  },
  methods:{
 readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      const baseUrl = `campaigns/${this.$route.params.id}/participation?page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, "&");
      this.$persistClient("get", url)
        .then((res) => {
          this.total= res.data.total
          this.camp = res.data.campaign
          e.success(res.data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
  }
}
</script>
